import React from "react";
import { FaCheckCircle } from "react-icons/fa";

const TIPS = [
  "Do not click unknown links or reply to suspicious messages",
  "Verify email IDs and domains before engaging",
  "Be cautious of calls claiming to be from us",
];

const SecurityNotice: React.FC = () => {
  return (
    <section className="bg-ep-green py-12 text-white lg:py-[50px]" aria-labelledby="security-notice-title">
      <div className="page-container grid gap-10 lg:grid-cols-[minmax(0,1fr)_1px_356px] lg:gap-10">
        {/* Fraud awareness */}
        <div className="lg:pb-8 lg:pl-10 lg:pt-[30px]">
          <h2 id="security-notice-title" className="font-serif text-[38px] font-normal leading-tight lg:text-[48px]">
            Security Notice
          </h2>
          <p className="mt-4 text-xs text-ep-on-dark">Fraud Awareness • All Domains</p>
          <p className="mt-6 font-serif text-[26px] leading-tight lg:text-[30px]">
            Fraudsters Stay vigilant.
          </p>
          <ul className="mt-7 space-y-5">
            {TIPS.map((tip) => (
              <li key={tip} className="flex items-start gap-3 text-[15px] text-ep-on-dark lg:text-base">
                <FaCheckCircle aria-hidden className="mt-[3px] shrink-0 text-white" />
                <span>{tip}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Divider */}
        <div aria-hidden className="h-px bg-[#A5B2A9] lg:h-auto lg:w-px" />

        {/* Safe payment */}
        <div className="lg:pb-8 lg:pt-10">
          <h3 className="font-serif text-[32px] font-normal leading-tight lg:text-[36px]">Safe Payment</h3>
          <p className="mt-6 text-base leading-[1.75] text-ep-on-dark lg:text-[17px]">
            Pay only through our official website or authorised links.
          </p>
          <hr className="my-8 border-0 border-t border-[#A5B2A9]" />
          <p className="text-[15px] leading-[1.8] text-ep-on-dark" lang="hi">
            भुगतान केवल आधिकारिक वेबसाइट से करें। किसी अज्ञात लिंक पर भरोसा न करें।
          </p>
        </div>
      </div>
    </section>
  );
};

export default SecurityNotice;
